import * as M from "@discovery/prelude/lib/data/maybe";
import * as styles from "./styles.css";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { head } from "@discovery/prelude/lib/data/iterable";
import { useMemo, useGlobalState, useState, useEffect, } from "@discovery/common-dplus/lib/hooks";
import { _IsUserPremiumFromPartners } from "@discovery/common-dplus/lib/state";
import { updateGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _tabs } from "@discovery/common-dplus/lib/state";
import { Lens } from "@discovery/prelude/lib/control/lens";
import { createPlayer, } from "../../utils/dplus/createPlayer";
import UpSellComponent from "./Error/UpSellComponent";
import { useUser } from "../../utils/hooks";
export const VideoWrapper = ({ children, }) => {
    return (React.createElement("div", { className: styles.videoWrapper },
        React.createElement("div", { className: styles.inner }, children)));
};
const View = ({ Player, streamId, onPlayNextE, }) => {
    const [{ showAllAccessPopUp }] = useGlobalState();
    const playerRef = React.useRef(null);
    const [isPlaying, setPlaying] = useState(false);
    const [wasPlaying, setWasPlaying] = useState(false);
    const [wasParentalLockOpen, setParentalLockOpen] = useState(false);
    const updateGlobalTabs = updateGlobalState(_tabs);
    useEffect(() => {
        if (playerRef.current) {
            const { pause, play } = playerRef.current;
            if (showAllAccessPopUp) {
                if (!wasParentalLockOpen)
                    setWasPlaying(isPlaying);
                pause();
            }
            else if (wasParentalLockOpen && wasPlaying) {
                setWasPlaying(false);
                play();
            }
            setParentalLockOpen(showAllAccessPopUp);
        }
    }, [showAllAccessPopUp, isPlaying, wasParentalLockOpen, wasPlaying]);
    const handleNext = (path, seasonNumber, id) => {
        updateGlobalState(Lens.prop("videoId"))((_videoId) => id);
        updateGlobalTabs((_old) => ({
            currentSelectedSeason: seasonNumber.toString(),
        }));
        onPlayNextE && onPlayNextE(path, seasonNumber, id);
    };
    return useMemo(() => (React.createElement(Player, { ref: playerRef, streamId: streamId, callbacks: {
            onPlayNext: (responseData) => {
                M.map(({ attributes, id }) => handleNext(attributes.path, attributes.seasonNumber, id), M.chain((video) => head(video), M.of(responseData === null || responseData === void 0 ? void 0 : responseData.data)));
            },
            onPlay: () => setPlaying(true),
            onPause: () => setPlaying(false),
        } })), [streamId, Player] // eslint-disable-line react-hooks/exhaustive-deps
    );
};
const PlayerView = ({ read, imaAdsConfig, streamIDM, packagesM, shortsPage, onPlayNextE, broadcastType, }) => {
    const { userPackagesM } = useUser();
    const Player = createPlayer(read, imaAdsConfig, shortsPage, broadcastType);
    const userPackages = M.fromMaybe(userPackagesM, []);
    const videoPackages = M.fromMaybe(packagesM, []);
    const [isPremiumUserFromPartner] = useGlobalState(_IsUserPremiumFromPartners);
    const premiumUpSell = videoPackages.some((v) => userPackages.includes(v)) ||
        isPremiumUserFromPartner;
    return (React.createElement("div", { className: styles.videoElementWrapper },
        React.createElement("div", { className: styles.videoElement },
            React.createElement(VideoWrapper, null, premiumUpSell ? (React.createElement(RenderMaybe, null, M.map((streamId) => (React.createElement(View, { Player: Player, streamId: streamId, onPlayNextE: onPlayNextE })), streamIDM))) : (React.createElement(UpSellComponent, { authService: read }))))));
};
export default PlayerView;

